import { Button } from "@/components/ui/button";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

export default function PrivacyPolicy() {
  const lastUpdate = new Date("2025-11-17").toLocaleDateString("pt-BR");
  return (
    <div className="dark min-h-screen bg-slate-950 text-white overflow-x-hidden">
      <PublicHeader />
      <section className="relative min-h-[320px] flex items-center overflow-hidden pt-16">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: 'url(/fundo-landing-page-1.jpg)' }} />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/80 via-primary/70 to-secondary/80" />
        <div className="container mx-auto px-8 py-16 relative z-10">
          <h1 className="text-3xl md:text-5xl font-bold">Política de Privacidade</h1>
          <p className="mt-3 text-sm md:text-base opacity-90">Última atualização: {lastUpdate}</p>
        </div>
      </section>
      <div className="container mx-auto px-4 py-12 max-w-3xl">

        <p className="mb-6 text-lg">
          Obrigado por escolher o Caixa Fácil Já. Esta Política de Privacidade explica, em linguagem simples, como coletamos, usamos, armazenamos e protegemos os seus dados. Nosso objetivo é garantir transparência e dar controle a você.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Quem somos</h2>
        <p className="mb-6">
          O Caixa Fácil Já é um sistema de gestão de caixa e vendas para pequenos e médios negócios. Ele permite registrar entradas, saídas, produtos, clientes e gerar relatórios de forma prática.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Dados acessados</h2>
        <p className="mb-4">Podemos coletar os seguintes dados quando você usa o sistema:</p>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Dados de conta para login: nome, e‑mail e foto de perfil quando você opta por entrar com Google.</li>
          <li>Dados do negócio: produtos, preços, categorias, clientes, fornecedores, vendas, despesas e configurações que você cadastra.</li>
          <li>Informações técnicas básicas: dispositivo, navegador e registros de acesso para segurança e suporte.</li>
        </ul>
        <p className="mb-6">Não coletamos conteúdo de e‑mails, arquivos do Google Drive ou dados sensíveis do Google Workspace. O acesso via Google é usado exclusivamente para autenticação.</p>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Como usamos os dados</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Autenticação e identificação de usuários.</li>
          <li>Operação do sistema: registrar vendas, despesas, extratos e relatórios.</li>
          <li>Personalização básica da experiência (exibir seu nome e preferências).</li>
          <li>Segurança, prevenção de fraudes e atendimento de suporte.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Compartilhamento de dados</h2>
        <p className="mb-6">Não vendemos seus dados. Compartilhamos apenas com serviços necessários para funcionamento e suporte, sempre de forma mínima:</p>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Provedor de autenticação e banco de dados em nuvem para login e armazenamento.</li>
          <li>Serviços opcionais ativados por você, como atendimento ao cliente (ex.: Chatwoot).</li>
          <li>Obrigações legais quando exigidas por autoridade competente.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Armazenamento e proteção</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Seus dados são armazenados em nuvem com criptografia em trânsito e controles de acesso.</li>
          <li>O acesso é restrito e registrado. Senhas e tokens não são expostos.</li>
          <li>Monitoramos a segurança e aplicamos atualizações regularmente.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Retenção e exclusão</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Mantemos os dados enquanto sua conta estiver ativa ou conforme necessário para prestar o serviço.</li>
          <li>Você pode solicitar exclusão dos seus dados a qualquer momento.</li>
          <li>Após exclusão, dados são removidos de forma segura, respeitando prazos legais aplicáveis.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Seus direitos</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Acessar e corrigir seus dados.</li>
          <li>Solicitar exportação dos seus registros.</li>
          <li>Solicitar exclusão e revogar consentimentos.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Login com Google e consentimento OAuth</h2>
        <p className="mb-4">Ao escolher “Continuar com Google”, o sistema solicita permissão apenas para obter seu nome, e‑mail e foto de perfil, com o objetivo de criar ou acessar sua conta.</p>
        <p className="mb-2">Como testar o fluxo de consentimento:</p>
        <ol className="list-decimal pl-6 space-y-2 mb-6">
          <li>Acesse a página inicial e clique em “Entrar” ou “Continuar com Google”.</li>
          <li>Selecione sua conta Google e aceite o consentimento.</li>
          <li>Você será redirecionado para a área de autenticação e, ao concluir, para o painel.</li>
          <li>Para revogar, acesse sua conta Google em "Segurança" → "Acessos de terceiros" e remova o Caixa Fácil Já.</li>
        </ol>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Menores de idade</h2>
        <p className="mb-6">O sistema é voltado para uso empresarial. Não é direcionado a crianças.</p>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Alterações nesta política</h2>
        <p className="mb-6">Atualizaremos esta página quando houver mudanças relevantes. A versão mais recente estará sempre disponível neste endereço.</p>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Contato</h2>
        <p className="mb-6">Se tiver dúvidas, solicitações de acesso, exportação ou exclusão de dados, entre em contato pelo e‑mail de suporte informado no sistema.</p>

        <div className="mt-10 flex gap-4">
          <Button asChild>
            <a href="/">Voltar para página inicial</a>
          </Button>
          <Button variant="outline" asChild>
            <a href="/politica-de-privacidade-ia">Política de Privacidade de IA/ML</a>
          </Button>
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
